import { Checkbox } from "@mui/material";
import { Dispatch, SetStateAction } from "react";

interface CheckboxHeaderProps {
  allIds: number[];
  allDepartmentIds: number[];
  selectedIds: number[];
  selectedDepartmentIds: number[];
  setSelectedIds: React.Dispatch<React.SetStateAction<number[]>>;
  setSelectedDepartmentIds: React.Dispatch<React.SetStateAction<number[]>>;
  total: number;
  notFolioSelected: number[];
  notDepartmentSelected: number[];
  setNotFolioSelected: React.Dispatch<React.SetStateAction<number[]>>;
  setNotDepartmentSelected: React.Dispatch<React.SetStateAction<number[]>>;
  isChecked:boolean;
  setIsChecked: Dispatch<SetStateAction<boolean>>
}

export const CheckboxHeader: React.FC<CheckboxHeaderProps> = ({
  allIds,
  allDepartmentIds,
  selectedIds,
  selectedDepartmentIds,
  setSelectedIds,
  setSelectedDepartmentIds,
  total,
  notFolioSelected,
  notDepartmentSelected,
  setNotFolioSelected,
  setNotDepartmentSelected,
  isChecked,
  setIsChecked
}) => {

  

  const handleHeaderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      /* setSelectedIds(allIds);
      setSelectedDepartmentIds(allDepartmentIds); */
      setSelectedIds([]);
      setSelectedDepartmentIds([]);
      setNotFolioSelected([]);
      setNotDepartmentSelected([]);
      setIsChecked(true)
    } else {
      setSelectedIds([]);
      setSelectedDepartmentIds([]);
      setNotFolioSelected([]);
      setNotDepartmentSelected([]);
      setIsChecked(false)
    }
  };

  return (
    <Checkbox
      checked={isChecked}
      onChange={handleHeaderChange}
      color="primary"
      //indeterminate={notFolioSelected.length > 0 && selectedIds.length + notFolioSelected.length < total}
    />
  );
};